/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ConfirmModal from 'app/components/common/ConfirmModal.jsx';

class SetPasswordModal extends React.Component {
    constructor(props) {
        super(props);

        this.dismissModal = this.dismissModal.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);

    }

    componentDidMount() {
        document.addEventListener('keyup', this.onKeyUp);
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.onKeyUp);
    }

    onKeyUp(e) {

        if (e.key === "Escape") {
            this.dismissModal();
        }

    }

    dismissModal(e) {

        this.props.dismissModal();

    }

    render() {
        return (
            <ConfirmModal
                modalCopy={"We don't have a password for this account. Click 'Set Password' to create one."}
                closeAction={this.dismissModal}
                cancelAction={this.dismissModal}
                confirmLabel={"Set Password"}
                cancelLabel={"cancel"}
                context="resetPassword"
                confirmAction={(e) => {
                    e.preventDefault();
                    this.props.router.navigate("/account#password");
                    this.dismissModal();
                }} />
        );
    }
}

SetPasswordModal.displayName = "SetPasswordModal";

export default SetPasswordModal;
